<!-- <div class="row m-0">
<div class="col-lg-12">
  <div class="btn-group"> -->
    <!-- <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button> -->
    <!-- <button pButton *ngIf="ownerStmtId" class="btn-delete p-button-outlined p-button-danger"
  (click)="onFormDelete()">Delete OwnerStmt</button> -->

  <!-- <button pButton *ngIf="!ownerStmtId" class="btn-addt p-button" (click)="formAdd()">View
OwnerStmt</button> -->

<!-- <button pButton *ngIf="ownerStmtId" class="btn-upt p-button" (click)="formUpdate()">Update
OwnerStmt</button> -->
<!-- </div>
</div>
</div> -->

<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>


  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>

  <!-- <button *ngIf="!ownerStmtId" (click)="formAdd()" style="float:left;top:-50px;padding-left:500px;background-color: blue;">
  View Owner Stmt
</button> -->

<div class="viewBtn">
  @if (ownerStmtId) {
    <button (click)="onOpenFormEdit()" class="btn btn-primary stmtBtn">View Owner Stmt</button>
  }
</div>

<!-- <hr> -->
<div [formGroup]="form1" class="forms w-100 d-block">
  <div class="row m-0">

    <div class="col-lg-12">
      @if (formAlert) {
        <div class="w-100 mb-3">
          <div class="w-100"
            style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
            <p><b>{{formAlert}}</b></p>
          </div>
        </div>
      }
    </div>

    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown class="w-100" [options]="statuses" formControlName="stmtStatus" optionLabel="name"
        optionValue="value" placeholder="Statement Status"></p-dropdown>
        <label for="Statement Status">Statement Status</label>
        @for (validation of validationMessages.stmtStatus; track validation) {
          <span>
            @if (form1.get('stmtStatus').hasError(validation.type) && (form1.get('stmtStatus').dirty || form1.get('stmtStatus').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="ownerName" id="ownerName" type="text" pInputText>
        <label for="name">Owner Name</label>
        @for (validation of validationMessages.ownerName; track validation) {
          <span>
            @if (form1.get('ownerName').hasError(validation.type) && (form1.get('ownerName').dirty || form1.get('ownerName').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="ownerAdrStreet" id="ownerAdrStreet" type="text" pInputText>
        <label for="ownerAdrStreet">Owner Adress Street</label>
        @for (validation of validationMessages.ownerAdrStreet; track validation) {
          <span>
            @if (form1.get('ownerAdrStreet').hasError(validation.type) && (form1.get('ownerAdrStreet').dirty || form1.get('ownerAdrStreet').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="ownerAdrCity" id="ownerAdrCity" type="text" pInputText>
        <label for="ownerAdrCity">Owner Adress City</label>
        @for (validation of validationMessages.ownerAdrCity; track validation) {
          <span>
            @if (form1.get('ownerAdrCity').hasError(validation.type) && (form1.get('ownerAdrCity').dirty || form1.get('ownerAdrCity').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="ownerAdrState" id="ownerAdrState" type="text" pInputText>
        <label for="ownerAdrState">Owner Adress State</label>
        @for (validation of validationMessages.ownerAdrState; track validation) {
          <span>
            @if (form1.get('ownerAdrState').hasError(validation.type) && (form1.get('ownerAdrState').dirty || form1.get('ownerAdrState').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="ownerAdrPostal" id="ownerAdrPostal" type="text" pInputText>
        <label for="ownerAdrPostal">Owner Adress Postal</label>
        @for (validation of validationMessages.ownerAdrPostal; track validation) {
          <span>
            @if (form1.get('ownerAdrPostal').hasError(validation.type) && (form1.get('ownerAdrPostal').dirty || form1.get('ownerAdrPostal').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="propertyAdrStreet" id="propertyAdrStreet" type="text" pInputText>
        <label for="propertyAdrStreet">Property Adress Street</label>
        @for (validation of validationMessages.propertyAdrStreet; track validation) {
          <span>
            @if (form1.get('propertyAdrStreet').hasError(validation.type) && (form1.get('propertyAdrStreet').dirty || form1.get('propertyAdrStreet').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="propertyAdrCity" id="propertyAdrCity" type="text" pInputText>
        <label for="propertyAdrCity">Property Adress City</label>
        @for (validation of validationMessages.propertyAdrCity; track validation) {
          <span>
            @if (form1.get('propertyAdrCity').hasError(validation.type) && (form1.get('propertyAdrCity').dirty || form1.get('propertyAdrCity').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="propertyAdrState" id="propertyAdrState" type="text" pInputText>
        <label for="propertyAdrState">Property Adress State</label>
        @for (validation of validationMessages.propertyAdrState; track validation) {
          <span>
            @if (form1.get('propertyAdrState').hasError(validation.type) && (form1.get('propertyAdrState').dirty || form1.get('propertyAdrState').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="propertyAdrPostal" id="propertyAdrPostal" type="text" pInputText>
        <label for="propertyAdrPostal">Property Adress Postal</label>
        @for (validation of validationMessages.propertyAdrPostal; track validation) {
          <span>
            @if (form1.get('propertyAdrPostal').hasError(validation.type) && (form1.get('propertyAdrPostal').dirty || form1.get('propertyAdrPostal').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="propertyCode" id="propertyCode" type="text" pInputText>
        <label for="propertyCode">Property Code</label>
        @for (validation of validationMessages.propertyCode; track validation) {
          <span>
            @if (form1.get('propertyCode').hasError(validation.type) && (form1.get('propertyCode').dirty || form1.get('propertyCode').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <textarea formControlName="ownerNotes" id="ownerNotes" [rows]="2" pInputTextarea></textarea>
        <label for="ownerNotes">Owner Notes</label>
        @for (validation of validationMessages.ownerNotes; track validation) {
          <span>
            @if (form1.get('ownerNotes').hasError(validation.type) && (form1.get('ownerNotes').dirty || form1.get('ownerNotes').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
        <label for="opsNotes">Ops Notes</label>
        @for (validation of validationMessages.opsNotes; track validation) {
          <span>
            @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <p-calendar formControlName="statementDate" inputId="statementDate" appendTo="body">
        </p-calendar>
        <label for="statementDate">Owner Statement Date</label>
        @for (validation of validationMessages.statementDate; track validation) {
          <span>
            @if (form1.get('statementDate').hasError(validation.type) && (form1.get('statementDate').dirty || form1.get('statementDate').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="revProgram" id="revProgram" type="text" pInputText>
        <label for="revProgram">Rev Program </label>
        @for (validation of validationMessages.revProgram; track validation) {
          <span>
            @if (form1.get('revProgram').hasError(validation.type) && (form1.get('revProgram').dirty || form1.get('revProgram').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <!--Many to one Relation-->

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <p-dropdown [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
          appendTo="body" optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode"
          [showClear]="false" placeholder="Select shortTermRental">
        </p-dropdown>
        <label for="Select shortTermRental">Select shortTermRental</label>
        @for (validation of validationMessages.shortTermRentalId; track validation) {
          <span>
            @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <!--reservation select field-->
    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <app-reservation-select (reservationInfoEvent)="destReservationInfoItem($event)" [title]="destTitle"
        [reservationId]="destReservationId"> </app-reservation-select>
        <span>
          @if (isDestReservationId) {
            <small class="p-invalid">Destination reservation is required
            </small>
          }
        </span>
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <p-dropdown [options]="users" formControlName="userId" optionLabel="firstName" optionValue="userId"
          [filter]="true" filterBy="firstName" [showClear]="false" placeholder="Select userId">
        </p-dropdown>
        <label for="Select userId">Select userId</label>
        @for (validation of validationMessages.userId; track validation) {
          <span>
            @if (form1.get('userId').hasError(validation.type) && (form1.get('userId').dirty || form1.get('userId').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

  </div>
</div>

<hr>

  @if (ownerStmtId) {
    <div>
      <div class="col-lg-12">
        <h6>Owner Stmt Rez</h6>
      </div>
      @if (ownerStmtId) {
        <app-owner-stmt-rez-list [ownerStmtId]="ownerStmtId" [showFilter]="false"
        [showPagination]="false"></app-owner-stmt-rez-list>
      }
    </div>
  }

  <hr>

    @if (ownerStmtId) {
      <div>
        <div class="col-lg-12">
          <h6>Owner Stmt Exp</h6>
        </div>
        @if (ownerStmtId) {
          <app-owner-stmt-exp-list [ownerStmtId]="ownerStmtId" [showFilter]="false"
          [showPagination]="false"></app-owner-stmt-exp-list>
        }
      </div>
    }

    <hr>

      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (ownerStmtId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete OwnerStmt</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!ownerStmtId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add OwnerStmt</button>
              }

              @if (ownerStmtId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update OwnerStmt</button>
              }
            </div>
          </div>
        </div>
      </div>

    </div>